module.exports = __webpack_public_path__ + "img/0Q3B1891_L_WoodMatted.9b3d7d41.jpg";